import { DEFAULT_API_CONFIG } from './apiConfig';
import { downloadExcelFileToBrowser } from '../helpers';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/orders`;

export const getOrderCancellationReasons = async () => {
  const url = `${baseRoute}/cancellation-reasons`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getCancellationTypes = async () => {
  const url = `${baseRoute}/cancellationtypes`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getOrderLineStatuses = async () => {
  const requestUrl = `${url}/OrderLineStatuses`;
  const headers = getHeaders();
  const response = await fetch(requestUrl, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

const getOrderLineStatusCode = status => status?.code ?? status?.Code ?? '';
const getOrderLineStatusDescript = status => status?.descript ?? status?.Descript ?? '';
const isOrderLineStatusCancellation = status =>
  status?.cancellation === true || status?.Cancellation === true;

export const getFieldRepCancellationStatuses = async () => {
  const statuses = await getOrderLineStatuses();
  return (statuses ?? []).filter(
    status => isOrderLineStatusCancellation(status) && !getOrderLineStatusCode(status).includes('CLIENT'),
  );
};

export const mapFieldRepCancellationStatusOptions = statuses =>
  (statuses ?? []).map(status => ({
    value:
      status.orderLineStatusLookupId ??
      status.OrderLineStatusLookupId ??
      status.orderLineStatusId ??
      status.OrderLineStatusId ??
      status.id ??
      status.Id,
    label: getOrderLineStatusDescript(status) || status.name || status.Name,
    code: getOrderLineStatusCode(status),
  }));

export const getOrderSpecialInstructions = async orderLineId => {
  const url = `${baseRoute}/specialinstructions/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getOrderById = async orderId => {
  const url = `${baseRoute}/${orderId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getInspectorAssignedToOrder = async orderId => {
  const url = `${baseRoute}/${orderId}/field-rep`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getDashboardLineChartData = async () => {
  const url = `${baseRoute}/dashboardLineChartData`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
export const getDashboardAreaChart = async () => {
  const url = `${baseRoute}/dashboardAreaChart`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getOrderReportPdf = async orderLineId => {
  const url = `${baseRoute}/pdf/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getOrderActivityHistory = async orderLineId => {
  const url = `${baseRoute}/${orderLineId}/history`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getOrderCommunication = async (orderLineId, opts = {}) => {
  const query = queryString.stringify(opts);
  const url = `${baseRoute}/${orderLineId}/communication?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getOrderServices = async orderLineId => {
  const url = `${baseRoute}/${orderLineId}/services`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getReportCodes = async orderLineId => {
  const url = `${baseRoute}/getavailablereportcodes/${orderLineId}/`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getAllReportCodes = async () => {
  const url = `${baseRoute}/reportCodes`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getBetterViewiFrame = async orderLineId => {
  const url = `${baseRoute}/BetterViewiFrame/${orderLineId}/`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getVexceliFrame = async orderLineId => {
  const url = `${baseRoute}/VexceliFrame/${orderLineId}/`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getBetterViewProperty = async orderLineId => {
  const url = `${baseRoute}/getBetterViewProperty/${orderLineId}/`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const createNewBetterViewOrderForiFrame = async orderLineId => {
  const url = `${baseRoute}/createNewBetterViewOrderForiFrame/${orderLineId}/`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const removeBetterViewData = async orderLineId => {
  const url = `${baseRoute}/removeBetterViewData/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const addBetterViewData = async orderLineId => {
  const url = `${baseRoute}/ProcessBetterviewForIframe/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getOrderableServices = async orderLineId => {
  const url = `${baseRoute}/${orderLineId}/orderableServices`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getDashboardCounts = async dashboardName => {
  const url = `${baseRoute}/dashboardCounts/${dashboardName}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getQaOrders = async (orderLineStatusLookupIds = []) => {
  let url = `${baseRoute}/orders`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  if (orderLineStatusLookupIds.length !== null) {
    url += `?orderLineStatusLookupIds=${JSON.stringify(orderLineStatusLookupIds).replace(/[\[\]']+/g, '')}`;
  }

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getGridExcelExport = async query => {
  let url = `${baseRoute}/export?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    console.log('Grid export failed...');
    return false;
  }

  let json = await response.json();
  const today = new Date();
  const date = `${today.getFullYear()}_${today.getMonth()}_${today.getDate()}`;

  downloadExcelFileToBrowser(json, `orders_export_${date}.xlsx`);
};

export const getOrderDetailMap = async orderLineId => {
  const url = `${baseRoute}/OrderDetailMap/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

/**
 * PUT
 */

export const updateOrderLine = async orderLine => {
  const url = `${baseRoute}/${orderLine.id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderLine),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const updateSpecialInstructions = async additionalDetailsVM => {
  const url = `${baseRoute}/specialinstructions`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(additionalDetailsVM),
  });
  return response.ok ? response.ok : Promise.reject(response);
  // return response.ok ? await response.json() : Promise.reject(response);
};

/**
 *
 * @param {int} orderLineId
 * @desc `sets OrderLineStatusLookup to 11 so the order will show up in the qa canceled orders grid`
 */
export const cancelOrderLine = async (orderLineId, cancellationReasonId, cancelComment) => {
  const url = `${baseRoute}/${orderLineId}/cancel`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify({
      cancellationReasonId,
      cancelComment,
    }),
  });

  const json = await response.json();

  return response.ok ? json : Promise.reject(json);
};

/**
 *
 * @param {int} orderLineId
 * @desc resets order with due date and insured phone number and re-notifies the agency
 */
export const resetInVisionOrder = async (orderLineId, form) => {
  const url = `${baseRoute}/resetInVisionOrder/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(form),
  });

  const json = await response.json();

  return response.ok ? json : Promise.reject(json);
};

/**
 *
 * @param {int} orderLineId
 * @desc `sets OrderLineStatusLookup to 11 so the order will show up in the qa canceled orders grid`
 */
export const convertOrderLineToSelfInspect = async form => {
  const url = `${baseRoute}/${form.orderLineId}/SelfInspection`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(form),
  });

  const json = await response.json();

  return response.ok ? json : Promise.reject(json);
};

export const bulkAssignOrdersToInspector = async (orderTickets, inspectorId) => {
  const url = `${baseRoute}/bulkAssignOrdersToInspector/${inspectorId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderTickets),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const bulkReleaseCallAheadOrders = async (orderTickets) => {
  const url = `${baseRoute}/bulkReleaseCallAheadOrders`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderTickets),
  });
  return response.ok ? {} : Promise.reject(response);
};

export const bulkReassignOrders = async orderTickets => {
  const url = `${baseRoute}/bulkReassign`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(orderTickets),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const bulkAssignOrdersToQa = async (orderTickets, qaId) => {
  // qaId may be null to unassign the orders and return them to the queue
  const url = `${baseRoute}/bulkAssignOrdersToQa${qaId ? `?qaId=${qaId}` : ''}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderTickets),
  });
  return response.ok ? {} : Promise.reject(response);
};

/**
 * POST
 */
export const addServiceToOrderLine = async (orderLineId, { serviceTypeId, ...opts }) => {
  const queryParams = queryString.stringify(opts);
  const url = `${baseRoute}/${orderLineId}/Service/${serviceTypeId}?${queryParams}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  return response.ok ? response : Promise.reject(response);
};

export const orderManipulationReopen = async oc => {
  const url = `${baseRoute}/ReopenOrder`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(oc),
  });
  return response.ok ? response : Promise.reject(response);
};
export const orderManipulationRecreate = async oc => {
  const url = `${baseRoute}/RecreateOrder`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(oc),
  });
  return response.ok ? response : Promise.reject(response);
};
export const orderManipulationConvert = async oc => {
  const url = `${baseRoute}/ConvertOrder`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(oc),
  });
  return response.ok ? response : Promise.reject(response);
};

export const orderManipulationLaunchRemote = async contactDetails => {
  const url = `${baseRoute}/addRemoteInVisionService`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(contactDetails),
  });
  return response.ok ? response : Promise.reject(response);
};

export const orderManipulationRemoveHold = async oc => {
  const url = `${baseRoute}/RemoveHold`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(oc),
  });
  return response.ok ? response : Promise.reject(response);
};

export const convertOrder = async (convertOrderBody, useOriginalAddress) => {
  console.log(convertOrderBody);
  let mRes;
  try {
    // if we have all the address fields, run address validation
    if (
      convertOrderBody?.insuredaddress &&
      convertOrderBody?.insuredstate &&
      convertOrderBody?.insuredcity &&
      convertOrderBody?.insuredzip
    ) {
      mRes = await addressValidation(convertOrderBody);

      if (!useOriginalAddress) {
        convertOrderBody.insuredaddress = mRes.addressLine1;
        convertOrderBody.insuredcity = mRes.city;
        convertOrderBody.insuredstate = mRes.state;
        convertOrderBody.insuredzip = mRes.postalCode;
      }
    }

    const url = `${baseRoute}/UpdateOrder?runAddressValidation=${!useOriginalAddress}`;
    let headers = getHeaders();
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(convertOrderBody),
    });
    return response.ok ? response : Promise.reject(response);
  } catch (ex) {
    console.log("Couldn't find address... " + ex);
  }
};

export const addressValidation = async convertOrderBody => {
  const queryParams = queryString.stringify({
    ad1: convertOrderBody.insuredaddress,
    city: convertOrderBody.insuredcity,
    st: convertOrderBody.insuredstate,
    zip: convertOrderBody.insuredzip,
  });

  const route = `${url}/FileImport/AddressValidation?${queryParams}`;
  let headers = getHeaders();
  const response = await fetch(route, {
    method: 'GET',
    headers,
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const createCommunicationMessage = async (orderLineId, message) => {
  const url = `${baseRoute}/${orderLineId}/message`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(message),
  });
  return response.ok ? response : Promise.reject(response);
};

export const updateInsuredContactInfo = async (orderLineId, form) => {
  const url = `${baseRoute}/${orderLineId}/InsuredContactInfo`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(form),
  });
  return response.ok ? response : Promise.reject(response);
};

export const getInsuredContactInfo = async orderLineId => {
  console.log({ orderLineId });
  const url = `${baseRoute}/${orderLineId}/InsuredContactInfo`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const updateCommunicationMessage = async (inboxMessageId, message) => {
  const url = `${baseRoute}/message/${inboxMessageId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(message),
  });
  return response.ok ? response : Promise.reject(response);
};

export const getValidOrdersForUser = async aspNetUserId => {
  const url = `${baseRoute}/GetValidOrdersForUser/${aspNetUserId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const getValidOrdersForQa = async qaId => {
  const url = `${baseRoute}/GetValidOrdersForQa/${qaId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const getValidOrdersForInspector = async inspectorId => {
  const url = `${baseRoute}/GetValidOrdersForInspector/${inspectorId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

// retrieve all order attachments
export const getOrderAttachments = async orderLineId => {
  const url = `${baseRoute}/OrderAttachment/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

// remove a document from an orderLine
export const removeOrderAttachment = async orderAttachmentId => {
  const url = `${baseRoute}/OrderAttachment/${orderAttachmentId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

// attach a document to an orderLine
export const uploadOrderAttachment = async (file, orderLineId) => {
  const queryParams = queryString.stringify({
    documentName: file.name,
  });

  const url = `${baseRoute}/OrderAttachment/${orderLineId}?${queryParams}`;
  let headers = getHeaders();
  delete headers['Content-Type'];

  const formData = new FormData();
  formData.append('file', file.data);

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getOrderableFormHeaders = async orderLineId => {
  const url = `${baseRoute}/OrderableFormHeaders/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const resendSelfInspectLink = async orderLineId => {
  const url = `${baseRoute}/${orderLineId}/ResendSelfInspectLink`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const aiPhotoReview = async orderLineId => {
  const url = `${baseRoute}/aiAnalyzeOrderPhotos/${orderLineId}`;
  let token = localStorage.getItem('token');
  let headers = token
    ? { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : {};
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(orderLineId),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const rerunHazardHubMigration = async orderLineId => {
  const url = `${baseRoute}/RerunHazardHubandVexcel/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getReviewedStatuses = async () => {
  const response = await fetch(`${baseRoute}/reviewed-statuses`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const updateReviewedStatus = async (orderLineId, reviewedStatusLookupId) => {
  const response = await fetch(`${baseRoute}/${orderLineId}/reviewed-status`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(reviewedStatusLookupId),
  });
  return response.ok ? Promise.resolve() : Promise.reject(response);
};

export const processPhotos = async orderLineId => {
  const response = await fetch(`${baseRoute}/processPhotoImmediatleyV2/${orderLineId}`, {
    method: 'POST',
    headers: getHeaders(),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const rebuildScreenshotImage = async orderLineId => {
  const response = await fetch(`${baseRoute}/rebuildscreenshotimage/${orderLineId}`, {
    method: 'GET',
    headers: getHeaders(),
  });
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json')
    ? await response.json().catch(() => null)
    : await response.text().catch(() => '');
  return response.ok ? payload : Promise.reject(payload || 'Request failed');
};

export const sendSelfInspectReminder = async orderLineId => {
  const response = await fetch(`${baseRoute}/${orderLineId}/SendSelfInspectReminder`, {
    method: 'POST',
    headers: getHeaders(),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
